var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2IconFlag = function SvgS2IconFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.69 2.678a.749.749 0 0 0-.675-.105l-.587.195A5.77 5.77 0 0 1 13.09 2.7l-2.727-.88a7.275 7.275 0 0 0-3.741-.195l-2.123.45V1.75a.75.75 0 0 0-1.5 0v16.5a.75.75 0 0 0 1.5 0v-4.617l2.433-.516a5.797 5.797 0 0 1 2.97.156l2.728.881a7.265 7.265 0 0 0 4.234.072l.62-.205A.749.749 0 0 0 18 13.31V3.285a.749.749 0 0 0-.31-.607Zm-1.19 10.09-.073.024a5.754 5.754 0 0 1-3.336-.065l-2.727-.881a7.304 7.304 0 0 0-3.74-.196L4.5 12.1V3.608l2.434-.515a5.786 5.786 0 0 1 2.969.156l2.727.88a7.259 7.259 0 0 0 3.87.166v8.473Z"
  })));
};
export default SvgS2IconFlag;